"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewLocation = getNewLocation;
function replaceRedirectUrl(matchedRoute, redirectUrl, url) {
    const matchedRouteWithoutWildcard = matchedRoute.replace('/*', '');
    const cleanUrl = url.replace(/\/$/, '');
    const capture = cleanUrl.replace(matchedRouteWithoutWildcard, '').replace(/^\//, '');
    return redirectUrl.replace('$1', capture);
}
function getNewLocation(route) {
    return route.route.endsWith('/*')
        ? replaceRedirectUrl(route.route, route.meta.redirect.location, route.url)
        : route.meta.redirect.location;
}
